import React from "react"
import PropTypes from "prop-types"
import { Typography } from "@material-ui/core"
import { completeUrlForHrefLink } from "../../commons/iFrameUtils"

/**
 * This component allows us to render HTML text within a Typography
 * The passed HTML should apply the style of Typography, however some HTML tags WILL be ignored
 * */
export default function TypographyHtml(props) {
  const { children } = props
  if (typeof children === "string" || children instanceof String) {
    const htmlText = completeUrlForHrefLink(children)
    return (
      <Typography {...props}>
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: htmlText }} />
      </Typography>
    )
  }
  return <Typography {...props}>{children}</Typography>
}

TypographyHtml.propTypes = {
  children: PropTypes.any.isRequired
}
